import React, { useEffect, useRef } from 'react';

const FeaturesOfVatCalculator = () => {
  const featureRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    featureRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => {
      featureRefs.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const features = [
    {
      icon: '🔄',
      title: 'Dual-Mode Functionality',
      description: 'Add VAT to net amounts or remove VAT from gross amounts. This bidirectional approach accommodates various business scenarios for invoicing and receipt analysis.'
    },
    {
      icon: '🌐',
      title: 'Multi-Currency & Global Support',
      description: 'Support for multiple currencies and country-specific VAT rates. Automatically handles different tax regulations across regions, from UK\'s 20% to varying EU rates and beyond.'
    },
    {
      icon: '⚡',
      title: 'Real-Time Calculations',
      description: 'User-friendly interfaces with instant feedback as you input values. Preset VAT rate buttons offer quick access to commonly used rates for faster calculations.'
    },
    {
      icon: '📊',
      title: 'Calculation History',
      description: 'Review previous computations and maintain accurate records. Keep track of your VAT calculations for better financial management and reporting.'
    },
    {
      icon: '🔒',
      title: 'Privacy-Focused Design',
      description: 'All calculations are performed locally without transmitting sensitive financial data. Your business information stays secure and private on your device.'
    },
    {
      icon: '📋',
      title: 'Copy & Export Features',
      description: 'Copy-to-clipboard functionality and detailed breakdown displays showing net amount, VAT amount, and gross total. Export results for easy record keeping.'
    }
  ];

  return (
    <section className="features-of-vat-section" id="features-of-vat">
      <div className="features-of-vat-container">
        <h2 className="section-title">Features of VAT Calculator</h2>
        <p className="section-subtitle">Comprehensive capabilities designed to streamline your tax calculations</p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="feature-card"
              ref={el => featureRefs.current[index] = el}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesOfVatCalculator;
